import React, { Fragment } from "react";

import "./BrandForm.css";
import Newloader from "../../../components/Loader/NewLoader/NewLoader";
import Input from "../../../components/Form/Input/Input";
import Button from "../../../components/Button/Button";
import ImageBox from "../../../components/ImageBox/ImageBox";
import { required, length } from "../../../util/validators";
import { generateBase64FromImage } from "../../../util/image";

const messages= {
    'brand[name_fa]': {
        'required': 'وارد کردن عنوان فارسی برند اجباری است',
        'minlength': 'عنوان فارسی برند نمی‌تواند کوتاه‌تر از 2 کاراکتر باشد',
        'maxlength': 'عنوان فارسی برند نمی‌تواند طولانی‌تر از 255 کاراکتر باشد',
        'persian_letters_only': 'تنها حروف فارسی مجاز است'
    },
    'brand[name_en]': {
        'required': 'وارد کردن عنوان انگلیسی برند اجباری است',
        'minlength': 'عنوان انگلیسی برند نمی‌تواند کوتاه‌تر از 2 کاراکتر باشد',
        'maxlength': 'عنوان فارسی برند نمی‌تواند طولانی‌تر از 255 کاراکتر باشد',
        'english_letters_only': 'تنها حروف انگلیسی مجاز است'
    },
    'brand[description]': {
        'required': 'وارد کردن شرح برای برند اجباری است',
        'minlength': 'متن وارد شده برای شرح برند نمی‌تواند کوتاه‌تر از 100 کاراکتر باشد',
        'maxlength': 'متن وارد شده برای شرح برند نمی‌تواند طولانی‌تر از 750 کاراکتر باشد',
    },
    'brand[origin]': {
        'required': 'وارد کردن محل نمایش برند اجباری است'
    },
    'brand[registration_image_id]': {
        'required': 'آپلود تصویر برگه ثبت برند اجباری است'
    },
}

const POST_FORM = {
  title: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 2 })],
  },
  enTitle: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 2 })],
  },
  description: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 70, max:750 })],
  },
  origin: {
    value: "true",
    valid: true,
    touched: true,
    errorMessage: "",
    validators: [],
  },
  imageUrl: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required],
  },
};


class BrandForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      postForm: POST_FORM,
      formIsValid: false,
      imagePreview: null,
      imageActive: false,
      loading: false,
    };

    this.onRadioValueChange = this.onRadioValueChange.bind(this);
  }
  
  componentDidUpdate(previousProps, previousState) {
    if (previousProps.editingData !== this.props.editingData) {
      let imagePreview;      
      let imageActive;      
      let formIsValid = false;      
      let updatedForm = POST_FORM;
      if (Object.keys(this.props.editingData).length !== 0) {    
        for (const inputName in updatedForm) {
           updatedForm[inputName].value = this.props.editingData[inputName];
           updatedForm[inputName].valid = true;
           updatedForm[inputName].touched = true;
           if (inputName === "origin") {
            updatedForm[inputName].value = this.props.editingData[inputName] ? "true" : "false";
          }          
          if (inputName === "imageUrl") {
            imagePreview = this.props.editingData[inputName] ? "https://api.shirazpc.com/" + this.props.editingData[inputName] : "";
            imageActive = this.props.editingData[inputName] ? true : false;
          }
        }
        formIsValid = true;
      }else{
        for (const inputName in updatedForm) {
          updatedForm[inputName].value = "";
          updatedForm[inputName].valid = false;
          updatedForm[inputName].touched = false;          
          updatedForm[inputName].errorMessage = "";
          if (inputName === "origin") {
            updatedForm[inputName].value = "true";
            updatedForm[inputName].valid = true;
            updatedForm[inputName].touched = true;
          }
        }
      }
      this.setState({
        postForm: updatedForm,
        imagePreview: imagePreview,
        formIsValid: formIsValid,
        imageActive: imageActive
      });
    }
  }

  postInputChangeHandler = (input, value, files) => {
    if (input==="imageUrl") {
      this.setState({
        imageActive: true,
        loading: true,
      });
    }
    
    
    if (files) {
      generateBase64FromImage(files[0])
        .then((b64) => {
          this.setState({ imagePreview: b64 });
        })
        .catch((e) => {
          this.setState({ imagePreview: null });
        });
    }

    console.log(files);

    this.setState((prevState) => {
      let isValid = true;
      let errorMessage = "";
      for (const validator of prevState.postForm[input].validators) {
        isValid = isValid && validator(value).hasError;
        errorMessage =
          !isValid && errorMessage === "" ? validator(value).errorMessage : errorMessage;
      }
      const updatedForm = {
        ...prevState.postForm,
        [input]: {
          ...prevState.postForm[input],
          valid: isValid,
          errorMessage: errorMessage,
          value: files ? files[0] : value,
        },
      };
      let formIsValid = true;
      for (const inputName in updatedForm) {
        formIsValid = formIsValid && updatedForm[inputName].valid;
      }

      return {
        postForm: updatedForm,
        formIsValid: formIsValid,
        loading: false,
      };
    });
  };

  onRadioValueChange(event) {
    const value = event.target.value;
    this.setState((prevState) => {
      const updatedForm = {
        ...prevState.postForm,
        ["origin"]: {
          ...prevState.postForm["origin"],
          value: value.toString(),
        },
      };
      
      return {
        postForm: updatedForm,
      };
    });
  }

  inputBlurHandler = (input) => {
    this.setState((prevState) => {
      return {
        postForm: {
          ...prevState.postForm,
          [input]: {
            ...prevState.postForm[input],
            touched: true,
          },
        },
      };
    });
  };
//////////////////////////////////////////////////////////////////////////////////////////
  cancelPostChangeHandler = () => {
    this.setState(
      {
        postForm: POST_FORM,
        formIsValid: false,
      });
    // this.props.onCancelEdit();
    this.props.toggleClass();
  };

  acceptPostChangeHandler = () => {
    if (this.state.formIsValid) {
      const post = {
        title: this.state.postForm.title.value,
        enTitle: this.state.postForm.enTitle.value,
        description: this.state.postForm.description.value,
        origin: this.state.postForm.origin.value === "true" ? true : false,
        imageUrl: this.state.postForm.imageUrl.value,
        categoryCode: 0,

        //label: this.props.label,
        editingCode: this.props.editingData.code || 0,
        oldImageUrl: this.props.editingData.imageUrl || "",
      };
      // console.log(post);
      this.props.onAcceptModal(post);

      let updatedForm = POST_FORM;
      for (const inputName in updatedForm) {
        updatedForm[inputName].value = "";
        updatedForm[inputName].valid = false;
        updatedForm[inputName].touched = false;          
        updatedForm[inputName].errorMessage = "";
        if (inputName === "origin") {
          updatedForm[inputName].value = true;
          updatedForm[inputName].valid = true;
          updatedForm[inputName].touched = true;
        }
      }

      this.setState({
        postForm: updatedForm,
        formIsValid: false,
        imagePreview: null,
      });
    } else {
      this.setState((prevState) => {
        let updatedForm = { ...prevState.postForm };

        for (const inputName in prevState.postForm) {
          let isValid = true;
          let errorMessage = "";
          for (const validator of prevState.postForm[inputName].validators) {
            console.log(inputName);
            isValid =
              isValid &&
              validator(prevState.postForm[inputName].value).hasError;
            errorMessage =
              !isValid && errorMessage === ""
                ? validator(prevState.postForm[inputName].value).errorMessage
                : errorMessage;
          }
          updatedForm = {
            ...updatedForm,
            [inputName]: {
              ...updatedForm[inputName],
              valid: isValid,
              errorMessage: errorMessage,
            },
          };
        }

        return {
          postForm: updatedForm,
        };
      });
    }
  };

  render() {
    return (
      <Fragment>
        <div className="mn-grid__col mn-grid__col--sm-6 mn-grid__col--lg-10 uk-padding-remove-left uk-padding-remove-right">
          <div className="mn-RD-profile__add-doc uk-width-1-1">
            <span className="uk-width-1-1 uk-text-right mn-brand-profile__add-doc-title">
              بارگذاری اطلاعات جدید
            </span>
            <form onSubmit={e => { e.preventDefault(); }}>
              <div className="mn-grid__row mn-grid__row--gap-lg mt-30">
                  <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--lg-6">
                      <Input 
                          id="title"
                          label={"نام فارسی برند:"}
                          placeholder={"نام فارسی برند را وارد کنید …"}
                          type="text"
                          control="input"
                          required="required"
                          onChange={this.postInputChangeHandler}
                          onBlur={this.inputBlurHandler.bind(this, "title")}
                          valid={this.state.postForm["title"].valid}
                          touched={this.state.postForm["title"].touched}
                          value={this.state.postForm["title"].value || ""}
                          validationError={
                              !this.state.valid &&
                              this.state.postForm["title"].errorMessage
                          }
                      />
                  </div>
                  <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--lg-6 mn-grid__col--sm-gap">
                      <Input
                          id="enTitle"
                          label={"نام انگلیسی برند:"}
                          placeholder={"عنوان انگلیسی برند …"}
                          type="text"
                          control="input"
                          required="required"
                          onChange={this.postInputChangeHandler}
                          onBlur={this.inputBlurHandler.bind(this, "enTitle")}
                          valid={this.state.postForm["enTitle"].valid}
                          touched={this.state.postForm["enTitle"].touched}
                          value={this.state.postForm["enTitle"].value || ""}
                          validationError={
                          !this.state.valid &&
                          this.state.postForm["enTitle"].errorMessage
                          }
                      />
                  </div>
              </div>
              <div className="mn-grid__row mn-grid__row--gap-lg">
                  <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial">
                      <Input
                          id="description"
                          label={"شرح برند:"}
                          type="text"
                          row="3"
                          cols=""
                          placeholder="توضیحات برند باید بین ۷۰ تا ۱۰۰ کلمه درباره‌ی تاریخچه و محصولات برند باشد …"
                          control="textarea"
                          required="required"
                          onChange={this.postInputChangeHandler}
                          onBlur={this.inputBlurHandler.bind(this, "description")}
                          valid={this.state.postForm["description"].valid}
                          touched={this.state.postForm["description"].touched}
                          value={this.state.postForm["description"].value || ""}
                          validationError={
                          !this.state.valid &&
                          this.state.postForm["description"].errorMessage
                          }
                      />
                  </div>
              </div>
              <div className="mn-grid__row mn-grid__row--gap-lg">
                  <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--lg-6 mn-grid__col--row-attr">
                      <label className="uk-form-label">نوع برند: <span className="uk-form-label__required"></span>
                      </label>
                      <div id="brandOrigin" className="field-wrapper">
                          <label className="c-ui-radio c-ui-radio--content c-ui-checkbox--auto">
                              <input type="radio" className="c-ui-radio__origin js-brand-origin" name="origin" value="true" id="iranianBrandContainer" checked={this.state.postForm["origin"].value == "true"} onChange={this.onRadioValueChange.bind(this)}/> 
                              <span className="c-ui-radio__check c-ui-radio__check--content"></span>
                              <span className="c-ui-radio__label c-ui-radio__label--content">ایرانی</span>
                          </label>
                          <label className="c-ui-radio c-ui-radio--content c-ui-checkbox--auto">
                              <input type="radio" className="c-ui-radio__origin js-brand-origin" name="origin"  value="false" id="foreignBrandContainer" checked={this.state.postForm["origin"].value == "false"} onChange={this.onRadioValueChange.bind(this)}/> 
                              <span className="c-ui-radio__check c-ui-radio__check--content"></span>
                              <span className="c-ui-radio__label c-ui-radio__label--content">خارجی</span>
                          </label>
                      </div>
                  </div>
              </div>
              <div className="mn-grid__row mn-grid__row--gap-lg">
                  <div id="iranianBrandLogo" className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--lg-6 mn-grid__col--row-attr">
                      <ImageBox
                      id="imageUrl"
                      label={"لوگوی برند:"}
                      type="text"
                      mode="simple"
                      control="input"
                      required="required"
                      imageActive={this.state.imageActive}
                      loading={this.state.loading}
                      accept="image/jpg,image/png,image/jpeg,image/png"
                      onChange={this.postInputChangeHandler}
                      onBlur={this.inputBlurHandler.bind(this, "imageUrl")}
                      imageUrl={this.state.imagePreview}
                      valid={this.state.postForm["imageUrl"].valid}
                      touched={this.state.postForm["imageUrl"].touched}
                      />
                  </div>
              </div>
            </form>
            <div className="uk-flex uk-flex-right uk-flex-bottom">
              <Button
                design="next"
                mode=""
                type="submit"
                loading={false}
                onClick={this.acceptPostChangeHandler}
              >
                {!this.props.isEditing ? "ثبت و بارگذاری" : "ویرایش و بارگذاری"}
              </Button>
              <Button
                design="reset"
                mode=""
                type="submit"
                loading={false}
                onClick={this.cancelPostChangeHandler}
              >
                {}
              </Button>
            </div>
          </div>
        </div>                        
      </Fragment>
    );
  }
}
export default BrandForm;
